import { Component, inject } from '@angular/core';
import { AsyncPipe } from "@angular/common";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { map, Observable, shareReplay } from "rxjs";
import { AdminLayoutService } from "../../services/admin-layout.service";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [
    AsyncPipe, RouterOutlet, RouterLink, RouterLinkActive, MatDrawerContainer,
    MatDrawer, MatDrawerContent, MatListModule, MatIconModule, MatDividerModule,
    MatButtonModule
  ],
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {
  private breakpointObserver = inject(BreakpointObserver);
  public adminLayoutService = inject(AdminLayoutService);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  toggleDrawer(): void {
    this.adminLayoutService.toggleAdminSidenav();
  }

  closeDrawer(): void {
    this.isHandset$.subscribe(isHandset => {
      if (isHandset) {
        this.adminLayoutService.setAdminSidenavState(false);
      }
    }).unsubscribe();
  }
}
